import { COUNTRY_CODE } from '@cemex-core/cmx-api';

export enum SPECIAL_SCENARIO_KEYS {
  ADDITIONAL_COMMENTS = 'SINST',
  SAME_DAY = 'SDAY',
  AFTER_CUT_OFF = 'ACUT',
  COLOR = 'SCOL',
  SPECIALIZED_VALUE_ADDED = 'SVAP',
  VOLUME_ALLOCATION = 'VOLM',
  MULTIPLE_PRODUCTS = 'MULTM',
  BIG_ORDER = 'LARGE',
  NO_AVAILABILITY = 'NOAV',
  WAITING_LIST = 'WLIS',
  FOREIGN_JOBSITES = 'FORE',
  AFFTER_CUT_OFF = 'ACUT',
  SPACING_VS_VOLUMEN = 'SPCVL',
  REQUEST_TIME_AVAILABILITY = 'AVAIL',
  COUNTER_OFFER = 'CTRO',
  TEMPERATURE_CONTROL = 'TEMP',
  NON_WORKING_DAY = 'NBDAY',
  JOBSITE_OUT_RANGE = 'OOR',
  OUT_SERVICE_HOURS = 'OUTS',
  CERTIFIED_TRUCKS_DRIVERS = 'CERTD',
}

export const SPECIAL_SCENARIOS_UK = [
  SPECIAL_SCENARIO_KEYS.BIG_ORDER,
  SPECIAL_SCENARIO_KEYS.NO_AVAILABILITY,
  SPECIAL_SCENARIO_KEYS.FOREIGN_JOBSITES,
  SPECIAL_SCENARIO_KEYS.SAME_DAY,
  SPECIAL_SCENARIO_KEYS.AFTER_CUT_OFF,
];

export const SPECIAL_SCENARIOS_USA = [
  SPECIAL_SCENARIO_KEYS.ADDITIONAL_COMMENTS,
  SPECIAL_SCENARIO_KEYS.COLOR,
  SPECIAL_SCENARIO_KEYS.SPECIALIZED_VALUE_ADDED,
  SPECIAL_SCENARIO_KEYS.VOLUME_ALLOCATION,
  SPECIAL_SCENARIO_KEYS.NO_AVAILABILITY,
  SPECIAL_SCENARIO_KEYS.TEMPERATURE_CONTROL,
  SPECIAL_SCENARIO_KEYS.NON_WORKING_DAY,
  SPECIAL_SCENARIO_KEYS.OUT_SERVICE_HOURS,
  SPECIAL_SCENARIO_KEYS.CERTIFIED_TRUCKS_DRIVERS,
  SPECIAL_SCENARIO_KEYS.JOBSITE_OUT_RANGE,
  SPECIAL_SCENARIO_KEYS.SAME_DAY,
  SPECIAL_SCENARIO_KEYS.AFTER_CUT_OFF,
];

export const SPECIAL_SCENARIOS_MX = [
  SPECIAL_SCENARIO_KEYS.BIG_ORDER,
  SPECIAL_SCENARIO_KEYS.NO_AVAILABILITY,
  SPECIAL_SCENARIO_KEYS.FOREIGN_JOBSITES,
  SPECIAL_SCENARIO_KEYS.SAME_DAY,
  SPECIAL_SCENARIO_KEYS.NON_WORKING_DAY,
  SPECIAL_SCENARIO_KEYS.WAITING_LIST,
];

export const SPECIAL_SCENARIOS_DEFAULT = [
  SPECIAL_SCENARIO_KEYS.ADDITIONAL_COMMENTS,
  SPECIAL_SCENARIO_KEYS.COLOR,
  SPECIAL_SCENARIO_KEYS.SPECIALIZED_VALUE_ADDED,
  SPECIAL_SCENARIO_KEYS.MULTIPLE_PRODUCTS,
];

export function specialScenariosByCountry(countryCode: COUNTRY_CODE) {
  switch (countryCode) {
    case COUNTRY_CODE.UNITED_KINGDOM:
      return SPECIAL_SCENARIOS_UK;
    case COUNTRY_CODE.USA:
      return SPECIAL_SCENARIOS_USA;
    case COUNTRY_CODE.MEXICO:
      return SPECIAL_SCENARIOS_MX;
    default:
      return SPECIAL_SCENARIOS_DEFAULT;
  }
}
